<script setup>
import { onBeforeUnmount, onBeforeMount, ref, computed } from "vue";
import { useRouter } from "vue-router";
import axios from 'axios';
import { useVuelidate } from '@vuelidate/core';
import { required, email } from '@vuelidate/validators';
import { useStore } from "vuex";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonButton from "@/components/ArgonButton.vue";
const body = document.getElementsByTagName("body")[0];
import logo from "@/assets/img/logo-ct-dark.png";

const url = ref(process.env.VUE_APP_API_URL);
const store = useStore();
const route = useRouter();
const userEmail = ref('');
const password = ref('');
const rememberMe = ref(false);
const isLoading = ref(false);
const errorHeader = ref('');
const rules = computed(() => {
  return {
    userEmail: { required, email },
    password: { required }
  }
});


const $v = useVuelidate(rules, {
  userEmail,
  password,
});

onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});

onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});

const login = () => {
  errorHeader.value = '';
  $v.value.$touch();
  if ($v.value.$invalid) {
    return;
  }
  isLoading.value = true;
  axios.post(url.value + 'api/login', { email: userEmail.value, password: password.value , rememberMe: rememberMe.value }).then(async (res) => {
    localStorage.setItem('authenticatedUserId', JSON.stringify(encodeURIComponent(btoa(res.data.user.id))));
    localStorage.setItem('sanctumToken', JSON.stringify(encodeURIComponent(btoa(res.data.token))));
    localStorage.setItem('email', JSON.stringify(encodeURIComponent(btoa(res.data.user.email))));
    await store.dispatch('getUser');
    isLoading.value = false;
    route.push('/');
  }).catch((error) => {
    isLoading.value = false;
    if (error.response?.data && error.response?.data.error) {
      errorHeader.value = error.response.data.error;
    }
    console.log(error);
  })
}
</script>
<template>
  <!-- <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar
          isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
        />
      </div>
    </div>
  </div> -->
  <main
    class="mt-0 main-content position-relative h-100 d-flex flex-column justify-content-center overflow-hidden custom-bg">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row justify-content-center">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card login-card">
                <div class="pb-0 card-header text-start">
                  <div class="d-flex justify-content-center mb-3 align-items-center">
                    <img :src="logo" alt="US Flag" class="custom-logo" />

                    <!-- <span class="ms-2 font-weight-bold me-2 font-s">Shipping Quote Automation</span> -->
                  </div>

                  <h5 class="text-center">Sign in</h5>
                  <p class="mb-0 fs-14 text-center">Enter your email and password to sign in</p>
                </div>
                <div class="card-body">
                  <form role="form">
                    <p v-if="errorHeader" class="text-danger">{{ errorHeader }}</p>
                    <div class="mb-3">
                      <argon-input id="email" v-model="userEmail" type="email" placeholder="Email" size="lg"
                        :class="{ 'is-invalid': $v.userEmail.$error }" />
                      <p class="text-danger" v-if="$v.userEmail.$error">
                        <span v-if="!$v.userEmail.$pending && !$v.userEmail.$model">Email is required.</span>
                        <span v-if="!$v.userEmail.$pending && $v.userEmail.$model && !$v.userEmail.$params">Invalid
                          email format.</span>
                      </p>
                    </div>
                    <div class="mb-3">
                      <argon-input id="password" v-model="password" type="password" placeholder="Password"
                        :class="{ 'is-invalid': $v.password.$error }" name="password" size="lg" />
                      <p class="text-danger" v-if="$v.password.$error">
                        <span v-if="!$v.password.$pending && !$v.password.$model">Password is required.</span>
                      </p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                      <argon-switch id="rememberMe" name="remember-me" v-model="rememberMe">Remember me</argon-switch>
                      <router-link to="/forgot-password" class="forgot-text">Forgot Password</router-link>
                    </div>

                    <div class="text-center">
                      <argon-button class="mt-4" type="button" variant="gradient" color="success" fullWidth size="lg" @click="login" :disabled="isLoading">Sign in</argon-button>
                    </div>
                  </form>
                </div>
                <!-- <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    Don't have an account?
                    <a href="/signup" class="text-success text-gradient font-weight-bold">Sign up</a>
                  </p>
                </div> -->
              </div>
            </div>
            <!-- <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                style="
                  background-image: url(&quot;https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/signin-ill.jpg&quot;);
                  background-size: cover;
                "
              >
                <span class="mask bg-gradient-success opacity-6"></span>
                <h4
                  class="mt-5 text-white font-weight-bolder position-relative"
                >
                  "Attention is the new currency"
                </h4>
                <p class="text-white position-relative">
                  The more effortless the writing looks, the more effort the
                  writer actually put into the process.
                </p>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<style>
.card-plain.login-card {
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;
  padding: 20px 0px;
}

.custom-bg {
  background: url("@/assets/img/image (1).webp");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  /* background-image: linear-gradient(310deg, #2dce89 0%, #2dcecc 100%);
  background: #a35c2e; */
  position: relative;
}

.custom-bg:before {
  position: absolute;
  content: '';
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  background: #00000082;
}

.custom-logo {
  max-width: 45px;
  width: 100%;
}

.fs-14 {
  font-size: 14px;
}

.form-switch .form-check-input:checked {
  border-color: #a35c2e !important;
  background-color: #a35c2e !important;
}

.form-control:focus {
  border-color: #a35c2e !important;
}

.bg-gradient-success {
  background: #a35c2e !important;
}

.text-gradient.text-success {
  color: #a35c2e !important;
  -webkit-text-fill-color: none;
}
</style>
